import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { CalendarForm } from "../../../calendars.types";
import { WeekDay } from "./week_day/week_day";

export const WeekDays = (): JSX.Element => {
  const { control } = useFormContext<CalendarForm>();
  const { fields } = useFieldArray({
    control,
    name: "nominalDays"
  });
  return (
    <>
      {fields.map((item, index) => (
        <WeekDay key={index} index={index} />
      ))}
    </>
  );
};
